<template>
  <div class="store-menu-container section-container">
    <div class="container">
      <h2>Menu</h2>
      <h3>Cake Donuts - $1.75 per &amp; $18.50 doz.</h3>
      <div class="container">
        <div class="row">
          <p class="col-lg-3 col-md-4 col-sm-6 col-xs-6">Plain</p>
          <p class="col-lg-3 col-md-4 col-sm-6 col-xs-6">Powdered Sugar</p>
          <p class="col-lg-3 col-md-4 col-sm-6 col-xs-6">Cinnamon Sugar</p>
          <p class="col-lg-3 col-md-4 col-sm-6 col-xs-6">Chocolate</p>
          <p class="col-lg-3 col-md-4 col-sm-6 col-xs-6">
            Chocolate w/ Peanuts
          </p>
          <p class="col-lg-3 col-md-4 col-sm-6 col-xs-6">
            Chocolate w/ Coconut
          </p>
          <p class="col-lg-3 col-md-4 col-sm-6 col-xs-6">
            Chocolate w/ Sprinkles
          </p>
          <p class="col-lg-3 col-md-4 col-sm-6 col-xs-6">
            Plain Old Fashioned
          </p>
          <p class="col-lg-3 col-md-4 col-sm-6 col-xs-6">
            Maple Old Fashioned
          </p>
          <p class="col-lg-3 col-md-4 col-sm-6 col-xs-6">
            Chocolate Old Fashioned
          </p>
          <p class="col-lg-3 col-md-4 col-sm-6 col-xs-6">Buttermilk Bar</p>
          <p class="col-lg-3 col-md-4 col-sm-6 col-xs-6">
            Apple Cinnamon Cake
          </p>
          <p class="col-lg-3 col-md-4 col-sm-6 col-xs-6">Blueberry Cake</p>
          <p class="col-lg-3 col-md-4 col-sm-6 col-xs-6">Cherry Cake</p>
        </div>
      </div>
      <h3>Raised Donut - $1.75 per &amp; $18.50 doz.</h3>
      <div class="container">
        <div class="row">
          <p class="col-lg-3 col-md-4 col-sm-6 col-xs-6">Glazed</p>
          <p class="col-lg-3 col-md-4 col-sm-6 col-xs-6">Chocolate</p>
          <p class="col-lg-3 col-md-4 col-sm-6 col-xs-6">Sugar</p>
          <p class="col-lg-3 col-md-4 col-sm-6 col-xs-6">
            Cinnamon Sugar Twist
          </p>
          <p class="col-lg-3 col-md-4 col-sm-6 col-xs-6">
            Maple Bar
          </p>
          <p class="col-lg-3 col-md-4 col-sm-6 col-xs-6">
            Chocolate Bar
          </p>
          <p class="col-lg-3 col-md-4 col-sm-6 col-xs-6">
            Boston Cream
          </p>
          <p class="col-lg-3 col-md-4 col-sm-6 col-xs-6">
            Coconut Cream
          </p>
          <p class="col-lg-3 col-md-4 col-sm-6 col-xs-6">
            Raspberry Filled
          </p>
          <p class="col-lg-3 col-md-4 col-sm-6 col-xs-6">
            Lemon Filled
          </p>
        </div>
      </div>
      <h3>Specials - $2.75 per &amp; $28.50 doz.</h3>
      <div class="container">
        <div class="row">
          <p class="col-lg-3 col-md-4 col-sm-6 col-xs-6">Apple Fritter</p>
          <p class="col-lg-3 col-md-4 col-sm-6 col-xs-6">Cherry Fritter</p>
          <p class="col-lg-3 col-md-4 col-sm-6 col-xs-6">Apple Bear Claw</p>
          <p class="col-lg-3 col-md-4 col-sm-6 col-xs-6">Cinnamon Roll</p>
          <p class="col-lg-3 col-md-4 col-sm-6 col-xs-6">Cinnamon Twist</p>
        </div>
      </div>
      <h3>Mixed Dozen (6 large &amp; 6 small) - $23.00</h3>
      <h3>Donut Holes - $0.35 per &amp; $3.50 doz.</h3>
      <h3>Cookie - $2.75 per</h3>
      <h3>Bacon Maple Bar / Cronut / Croissant - $3.50 per</h3>
      <h4>Note - Less than 6 donuts in a box (add $0.50)</h4>
    </div>
  </div>
</template>

<script>
export default {
  name: "StoreMenu",
  mounted() {}
};
</script>

<style lang="scss" scoped>
.store-menu-container {
  p {
    margin: 0 0 10px;
  }
  h3 {
    color: var(--color-dark-2);
    font-weight: 400;
    margin: 20px 0 10px;
  }
}
</style>
